export default class CmsBaseClass {
    constructor(data) {
        if (this.autoGenerateId) {
            this.id = generateGuid();
        }

        if (data) {
            this.loadSave(data);
        }
    }

    get ignoredFields() {
        return []
    }

    /**
     * To distinguish content from style
     * TODO Refactor all style properties inside a style object instead
     * @returns {*[]}
     */
    get contentFields() {
        return []
    }

    get autoGenerateId() {
        return true
    }

    getNestedValue(fieldPath) {
        if (!fieldPath || typeof fieldPath !== `string`) {
            return;
        }
        if (fieldPath.indexOf(`.`) === -1) {
            return this[fieldPath];
        }

        // Get value from Nested Object xxx.floor.name  [root]?optional.[type].[field]
        const path = fieldPath.split(`.`);
        let value = this;
        for (let parent of path) {
            if (!value) {
                break;
            }
            // For special fields such as map-link
            if (value && typeof value.getField === `function`) {
                value = value.getField(parent);
            } else {
                value = value[parent];
            }
        }
        return value;
    }

    getField(field) {
        return this[field];
    }

    loadSave(data) {
        if (data._id) {
            data.id = data._id;
            delete data._id;
        }

        for (let key in data) {
            this[key] = data[key];
        }
        this.onSaveLoaded(data);
    }

    onSaveLoaded(data) {

    }

    loadStyle(data) {
        for (let key in data) {
            // Tmp, until style refactoring, copy all keys that are not of type content
            if (this.contentFields.indexOf(key) >= 0 || key === `id`) {
                continue;
            }
            const field = this[key];
            const value = data[key];
            if (field && field instanceof Array) {
                // ignore for now
                // for (let item of field) {
                //     field.loadStyle(value);
                // }
            } else if (field && typeof field === `object` && typeof field.loadStyle === `function`) {
                field.loadStyle(value);
            } else {
                this[key] = value;
            }
        }
        this.onStyleLoaded(data);
    }

    onStyleLoaded(data) {

    }

    mergeDefaults(base, defaultValues) {
        if (!base || typeof base !== `object`) {
            return defaultValues;
        }
        for (let key in defaultValues) {
            if (base[key] === undefined) {
                base[key] = defaultValues[key];
            }
        }
        return base;
    }

    // When initializing
    generateId() {
        this.id = generateGuid();
    }

    // When duplicating
    applyNewId() {
        this.generateId();
    }

    duplicate() {
        let copy = new this.constructor();
        copy.loadSave(structuredClone(this.toJSON()));
        copy.applyNewId();

        console.log(`duplicate`, copy);
        return copy;
    }

    toJSON() {
        let data = {};

        for (let key in this) {
            if (this.ignoredFields.indexOf(key) >= 0) {
                continue;
            }
            if (key !== `ignoredFields` && typeof this[key] !== `function`) {
                if (!this[key]) {
                    data[key] = this[key];
                } else if (this[key].constructor === Proxy) {
                    // ignore field
                } else if (this[key].constructor === Array) {
                    data[key] = [];
                    for (let item of this[key]) {
                        if (item && typeof item === `object` && typeof item.toJSON === `function`) {
                            data[key].push(item.toJSON());
                        } else {
                            data[key].push(item);
                        }
                    }
                } else if (typeof this[key] === `object` && typeof this[key].toJSON === `function`) {
                    data[key] = this[key].toJSON();
                }/* else if (typeof this[key] === `object` && this[key] !== null) {
                // create infinite loops
                    data[key] = clone(this[key]);
                }*/ else {
                    data[key] = this[key];
                }
            }
        }

        return data;
    }

    delete() {
        if (this.deleted === false) {
            this.beforeDelete();
            this.deleted = true;
        } else {
            console.error(`Already Deleted`);
        }
    }

    beforeDelete() {
        // to override
    }

    isValid() {
        return true;
    }
}
